if (document.querySelector('.mysplide')) {
  /* Auto-advance is opt-in PER BANNER, driven by data attributes that
     sections/banner.liquid renders from its own settings. It is deliberately
     not a global flag: the banner section is used on 8 templates including the
     homepage, and turning it on here would start all of them rotating.

     Three things switch it off even when the setting is on:
       - any slide carrying a <video>, because advancing away from a
         half-played video is worse than not advancing at all;
       - prefers-reduced-motion, which is a real accessibility requirement for
         carousels, not a nicety;
       - a single slide, where a loop just re-renders the same image. */
  var splideEl = document.querySelector('.mysplide');
  var wantsAutoplay = splideEl.dataset.autoplay === 'true';
  var slideCount = splideEl.querySelectorAll('.splide__slide').length;
  var hasVideo = !!splideEl.querySelector('video');
  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoplayOn = wantsAutoplay && !hasVideo && !reduceMotion && slideCount > 1;
  var interval = parseInt(splideEl.dataset.interval, 10);
  if (!interval || interval < 1000) interval = 3000;

  var splide = new Splide('.mysplide', {
    type: 'loop',       // Optional: makes it loop
    pagination: true,   // Show dots
    arrows: true,       // Optional: show arrows
    autoplay: autoplayOn,
    interval: interval,
    pauseOnHover: true, // don't yank the slide away from someone reading it
    pauseOnFocus: true  // keyboard users keep control
  });

  splide.mount();

  window.addEventListener('load', function () {
    gsap.to(".head-line", {
      width: "100%",
      opacity: 1,
      duration: 1.2,
      ease: "power2.out"
    });
  });
}




/* ---------------------------------------------------------------------------
   GSAP-dependent block, gated on window.__gsapReady.

   GSAP + ScrollTrigger are script-inserted in theme.liquid, which makes them
   force-async (the `defer` set on a script-created element is ignored). This
   file is parser-inserted with `defer`, so it always ran FIRST and bound to
   the no-op GSAP shim: every ScrollTrigger silently failed to register and
   every scroll animation died with no console error. Broken since v12.

   __gsapReady resolves once real GSAP + ScrollTrigger have executed, or
   immediately on mobile where the shim is the intended implementation.
   --------------------------------------------------------------------------- */
(window.__gsapReady || Promise.resolve()).then(function () {

 gsap.registerPlugin(ScrollTrigger);

//   const image = document.querySelector('.text-line');

//   gsap.to(image, {
//     maxWidth: 185,
//     scrollTrigger: {
//       trigger: image,
//       start: "top 70%", 
//       end: "top 70%",
//       scrub: 1,
//       markers: true 
//     }
//   });

const image_scale = document.querySelectorAll('.text-left img.head-line');

image_scale.forEach((img) => {
  gsap.to(img, {
    rotation: -21,
    scale: 1,
    scrollTrigger: {
      trigger: img,
      start: "top 85%",
      end: "top 85%",
      scrub: 1,
      // markers: true
    }
  });
});


  const image_span = document.querySelector('.span_img');

  gsap.to(image_span, {
    scale: 1,
    scrollTrigger: {
      trigger: image_span,
      start: "top 85%", 
      end: "top 85%",
      scrub: 1,
      // markers: true 
    }
  });


  gsap.from(".gradient-img-text_media", {
    x: 100,             
    opacity: 0,       
    duration: 1,     
    ease: "power3.out", 
    scrollTrigger: {
      trigger: ".gradient-img-text", 
      start: "top 80%",       
      toggleActions: "play none none reverse" 
    }
  });

  gsap.from(".ct-newsletter_media", {
    x: -100,             
    opacity: 0,       
    duration: 1,     
    ease: "power3.out", 
    scrollTrigger: {
      trigger: ".ct-newsletter", 
      start: "top 80%",       
      toggleActions: "play none none reverse" 
    }
  });

  gsap.from(".gradient-img-text-2_media img.gradient_media", {
    scaleX: 0,          // start at zero width
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".gradient-img-text-2",
      start: "top 80%",
      toggleActions: "play none none reverse"
    }
  });

  // gsap.set(".imgblock_2.imgblock", { clipPath: "inset(100% 0 0 0)" });
  // gsap.to(".imgblock_2.imgblock", {
  //   clipPath: "inset(0% 0 0 0)", // fully revealed
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".about-img_text",
  //     start: "top top",
  //     end: "+=500",
  //     scrub: true,
  //     pin: true
  //   }
  // });

  gsap.set(".imgblock", { scale: 1, opacity: 1, zIndex: 2 });
  gsap.set(".imgblock_2", { scale: 0.8, opacity: 0, zIndex: 1 });

  gsap.timeline({
    scrollTrigger: {
      trigger: ".about-img_text",
      start: "top top",
      end: "+=500",
      scrub: true,
      pin: true
    }
  })
  .to(".imgblock", {
    scale: 0.8,
    opacity: 0,
    ease: "none"
  }, 0)
  .to(".imgblock_2", {
    scale: 1,
    opacity: 1,
    ease: "none"
  }, 0);

  //  const sections = document.querySelectorAll('.pro_info-main');

  // sections.forEach(section => {
  //   const badge = section.querySelector('.pro_info_badge');

  //   if (badge) {
  //     gsap.to(badge, {
  //       scale: 1,
  //       duration: 0.5,
  //       ease: "power2.out",
  //       scrollTrigger: {
  //         trigger: section,
  //         start: "top 90%",  
  //         toggleActions: "play none none none",
  //         // markers: true 
  //       }
  //     });
  //   }
  // });


const sections = document.querySelectorAll('.pro_info-main');

sections.forEach((section, index) => {
  const badge = section.querySelector('.pro_info_badge');

  if (badge) {
    gsap.to(badge, {
      scale: 1,
      duration: 0.5,
      delay: index * 0.2, // delay each badge based on its index
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 90%",
        toggleActions: "play none none none",
        // markers: true
      }
    });
  }
});
});  /* end __gsapReady gate */


/* Anchor Scrolling
   Delegated, so anchors rendered after page load (FAQ accordions, the chat
   widget, quick-add panels) are covered too. The old version bound at parse
   time and missed all of them.

   Two failure modes it also had:
   - It called preventDefault() before resolving the target, then ran
     querySelector(href).scrollIntoView(). href="#" resolves to null, so every
     one of those threw a TypeError with the default already suppressed -- a
     dead link. There are 5 such anchors in the theme.
   - href="#" is not a valid selector for querySelector, and neither is any
     href whose fragment starts with a digit, so the throw was not always a
     null dereference. Both are handled by resolving defensively below.

   behavior is deliberately omitted: scrollIntoView() defaults to 'auto', which
   defers to the computed scroll-behavior, so custom.css owns the motion and
   prefers-reduced-motion is honoured in one place. */
document.addEventListener('click', function (e) {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href || href === '#') return;

    let target = null;
    try {
        target = document.querySelector(href);
    } catch (_err) {
        target = document.getElementById(href.slice(1));
    }
    if (!target) return;

    e.preventDefault();
    document.querySelectorAll('a[href^="#"]').forEach(a => a.classList.remove('active'));
    anchor.classList.add('active');
    target.scrollIntoView();
});



/** Product Page Media Gallery Custom Dots **/
document.addEventListener('DOMContentLoaded', function () {
  const mediaGallery = document.querySelector('media-gallery');
  const mediaList = document.querySelector('.product__media-list');
  const dots = document.querySelectorAll('.ct-main-product .dot');

  if (!mediaGallery || !mediaList || !dots.length) return;

  function setActiveDot(index) {
    document.querySelector('.dot.active')?.classList.remove('active');
    const dot = document.querySelector(`.dot[data-index="${index}"]`);
    dot?.classList.add('active');
  }

  // Click on dots
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.index);
      const offset = mediaList.children[index].offsetLeft;

      mediaList.scrollTo({
        left: offset,
        behavior: 'smooth'
      });

      setActiveDot(index);
    });
  });

  // Detect image change via arrow/thumb/keyboard
  const observer = new MutationObserver(() => {
    const activeMedia = mediaList.querySelector('[media-id][aria-current="true"]');
    if (!activeMedia) return;

    const index = Array.from(mediaList.children).indexOf(activeMedia);
    if (index > -1) setActiveDot(index);
  });

  observer.observe(mediaList, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });

  // Optional: update on scroll (e.g., mobile swipe)
  mediaList.addEventListener('scroll', () => {
    const scrollLeft = mediaList.scrollLeft;
    const childWidth = mediaList.children[0].clientWidth;

    const index = Math.round(scrollLeft / childWidth);
    setActiveDot(index);
  });
});


/* Flip card toggle — vanilla JS (no jQuery dependency) */
document.querySelectorAll('.ct-flip-card_item').forEach(function(el) {
  el.addEventListener('click', function() { this.classList.toggle('active'); });
});
document.querySelectorAll('.flip-image_wrp').forEach(function(el) {
  el.addEventListener('click', function() { this.classList.toggle('active'); });
});






// var splide = new Splide( '.cart_product_list', {
//   arrows: false,
//   pagination: false,
//   perPage: 3,
//   rewind : true,
// } );

// splide.mount();

let cart_splide;
let cart_splide_pending = false;
function initCartSplide() {
  // Coalesce multiple calls in the same tick (called from cart-drawer.js, cart.js, custom.js init)
  if (cart_splide_pending) return;
  cart_splide_pending = true;
  requestAnimationFrame(() => {
    cart_splide_pending = false;
    const slider = document.querySelector('.cart_product_list');
    if (!slider) return;

    // Destroy previous instance since section re-render replaces the DOM
    if (cart_splide) {
      try { cart_splide.destroy(); } catch(e) {}
      cart_splide = null;
    }

    // Skip init if slider has no items (empty collection)
    if (!slider.querySelector('.splide__slide')) return;

    cart_splide = new Splide(slider, {
      arrows: false,
      pagination: false,
      perPage: 3,
      rewind: true,
      autoWidth: true,
    });
    cart_splide.mount();
  });
}
initCartSplide();

if (document.body.clientWidth > 750) {
// gsap.registerPlugin(ScrollTrigger);
// // Set stacking order (z-index)
// gsap.set(".imgblock", {
//   zIndex: (i, target, targets) => targets.length - i
// });
// var images = gsap.utils.toArray(".imgblock:not(:last-of-type)");
// // Loop through all images except the last one
// images.forEach((image, i) => {
//   var tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".about-img_text_wrp",
//       start: () => "top -" + window.innerHeight * (i + 0.5),
//       end: () => "+=" + window.innerHeight,
//       scrub: true,
//       toggleActions: "play none reverse none",
//       invalidateOnRefresh: true
//     }
//   });
//   // Instead of shrinking height, fade out
//   tl.to(image, {
//     opacity: 0,
//     pointerEvents: "none",
//     duration: 1
//   });
// });
// // Master ScrollTrigger to pin the whole section
// ScrollTrigger.create({
//   trigger: ".about-img_text_wrp",
//   scrub: true,
//   // markers: true,
//   pin: true,
//   start: () => "top top",
//   end: () => "+=" + (images.length + 1) * window.innerHeight,
//   invalidateOnRefresh: true
// });
}

if (document.body.classList.contains("ct_template_recipe")) {
var recipe_slider = new Splide( '.recipe-slider', {
  classes: {
		prev  : 'splide__arrow--prev',
		next  : 'splide__arrow--next',
  },
  arrows: true,
  perPage: 3,
  rewind : true,
  pagination: false,
  breakpoints: {
    989: {
      perPage: 2
    },
    749: {
      perPage: 1,
      arrows: false,
      pagination: true
    },
  },
});
recipe_slider.mount();

var recipe_slider2 = new Splide( '.recipe-slider-section2 .recipe-slider', {
  classes: {
		prev  : 'recipe-slider_arw_2 splide__arrow--prev',
		next  : 'recipe-slider_arw_2 splide__arrow--next',
  },
  arrows: true,
  perPage: 3,
  rewind : true,
  pagination: false,
  breakpoints: {
    989: {
      perPage: 2
    },
    749: {
      perPage: 1,
      arrows: false,
      pagination: true
    },
  },
});
recipe_slider2.mount();

var recipe_slider3 = new Splide( '.recipe-slider-section3 .recipe-slider', {
  classes: {
		prev  : 'recipe-slider_arw_3 splide__arrow--prev',
		next  : 'recipe-slider_arw_3 splide__arrow--next',
  },
  arrows: true,
  perPage: 3,
  rewind : true,
  pagination: false,
  breakpoints: {
    989: {
      perPage: 2
    },
    749: {
      perPage: 1,
      arrows: false,
      pagination: true
    },
  },
});
recipe_slider3.mount();
}
/*
  V12 disable: this block sliced the mobile product grid into rows of 4
  cards, each row a horizontal scroller (CSS .product-slider-row +
  .product-slider). On a 375px viewport with cards at calc(50% - 5px),
  only 2 of 4 cards in each row were visible; the other 2 sat behind a
  horizontal swipe with no visible scroll affordance.

  In V11 this block silently never ran because custom.js threw an
  earlier GSAP error (gsap was loaded directly and a chained call
  pattern crashed) which killed the script before reaching this slicer.
  V12's GSAP no-op shim fixed that crash, which inadvertently activated
  the slicer and exposed its broken UX -- products 3+4 of every 4-pack
  vanished behind an invisible swipe.

  Removing the slicer entirely. Mobile collection grid now wraps
  vertically as a normal 2-up flex grid, all products visible by
  scrolling down. This was the intended UX all along.
*/


/* Product page cart drawer — vanilla JS (no jQuery dependency) */
document.addEventListener('click', function(e) {
  if (e.target.closest('.ct_template_page_product .header__icon--cart')) {
    var btn = document.querySelector('.shipping_cart_open');
    if (btn) btn.click();
  }
  if (e.target.closest('.ct_template_page_product .shipping_cart_open')) {
    document.body.classList.add('cart_drawer_pdp');
  }
  if (e.target.closest('.ct_template_page_product .cart-drawer__overlay')) {
    document.body.classList.remove('cart_drawer_pdp');
    var drawer = e.target.closest('cart-drawer');
    if (drawer) drawer.classList.add('active');
  }
});

/* FlexyPass account page renders inside an OPEN shadow root; its page background is
   a hardcoded Tailwind bg-[#f8f9fa] that theme CSS cannot reach across the shadow
   boundary. Inject a style INTO the shadow root so it matches the site off-white.
   NOTE: FlexyPass mounts + populates the shadow root asynchronously, and shadow
   mutations are NOT visible to a light-DOM MutationObserver — so we POLL for it, and
   keep re-injecting (cheap) so a FlexyPass re-render during load cannot wipe it. */
(function patchFlexypassBg() {
  function getShadow() {
    var root = document.getElementById('flexypass-account-root');
    if (!root) return null;
    if (root.shadowRoot) return root.shadowRoot;
    var kids = root.querySelectorAll('*'); // shadow host may be a descendant
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].shadowRoot) return kids[i].shadowRoot;
    }
    return null;
  }
  function inject() {
    try {
      var sr = getShadow();
      if (!sr) return;
      if (sr.getElementById && sr.getElementById('everaw-flexypass-bg')) return;
      var style = document.createElement('style');
      style.id = 'everaw-flexypass-bg';
      style.textContent = '#flexypass-app-container,.min-h-screen{background-color:#FFFFF9 !important;}';
      sr.appendChild(style);
    } catch (e) {}
  }
  if (!document.getElementById('flexypass-account-root')) return; // not the account page
  var count = 0;
  var iv = setInterval(function () {
    inject();
    if (++count >= 40) clearInterval(iv); // poll ~20s (40 x 500ms) then stop
  }, 500);
})();


/* FAQ accordion: one open at a time, with a height transition.
   ------------------------------------------------------------------
   The section renders native <details>/<summary>, which gives no exclusivity
   and no animation -- rows snap open and every row can be open at once.

   Scoped to .collapsible-content on purpose. Product pages use .accordion for
   spec tabs, where "opening one closes the others" is the wrong behaviour, so
   widening the selector would be a silent regression there.

   Height is measured with getBoundingClientRect AFTER `open` is set rather than
   scrollHeight, because .accordion__content carries padding and scrollHeight
   under-reports it. margin-bottom is animated alongside height; leaving it out
   drops 1.5rem instantly at the end of the close and reads as a jolt. */
(function () {
  var DURATION = 260;
  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function run(details, opening) {
    var c = details.querySelector('.accordion__content');
    if (!c) { details.open = opening; return; }

    if (details._anim) { details._anim.cancel(); details._anim = null; }

    // THE BOUNCE. Setting details.open lays the row out at full height
    // immediately, but a WAAPI animation does not take effect until the next
    // frame, so the browser got one painted frame of the row fully open before
    // it snapped to 0 and expanded again. Pinning height and margin inline in
    // the SAME synchronous block closes that window -- nothing yields between
    // the measurement and the pin, so the full-height frame can never paint.
    if (opening) details.open = true;
    var rect = c.getBoundingClientRect().height;
    var mb = parseFloat(getComputedStyle(c).marginBottom) || 0;
    if (opening) {
      c.style.height = '0px';
      c.style.marginBottom = '0px';
    }

    var shut = { height: '0px', marginBottom: '0px' };
    var full = { height: rect + 'px', marginBottom: mb + 'px' };

    // overflow is clipped only for the duration: .accordion__content sets
    // overflow-x:auto so wide content can scroll, and clobbering that would
    // cut off tables and long links once the row is open.
    var prevOverflow = c.style.overflow;
    c.style.overflow = 'hidden';
    if (!opening) details.setAttribute('data-closing', '');

    // fill:'both' holds the end value past the last frame. Without it the
    // effect drops at completion and the inline height:0 set above shows
    // through until onfinish runs a task later -- a single frame of collapsed
    // row, which is the same flash this function exists to avoid. onfinish
    // clears the inline styles FIRST and only then cancels the fill, so the
    // natural height is already in place when the animation lets go.
    var anim = c.animate([opening ? shut : full, opening ? full : shut],
                         { duration: DURATION, easing: EASE, fill: 'both' });
    details._anim = anim;
    anim.onfinish = function () {
      c.style.overflow = prevOverflow;
      c.style.height = '';
      c.style.marginBottom = '';
      details.removeAttribute('data-closing');
      if (!opening) details.open = false;
      anim.cancel();
      details._anim = null;
    };
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.collapsible-content summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    e.preventDefault();
    var wasOpen = details.open;
    var section = details.closest('.collapsible-content');
    var siblings = section
      ? Array.prototype.filter.call(section.querySelectorAll('details[open]'),
                                    function (d) { return d !== details; })
      : [];

    if (reduced()) {
      siblings.forEach(function (d) { d.open = false; });
      details.open = !wasOpen;
      return;
    }

    siblings.forEach(function (d) { run(d, false); });
    run(details, !wasOpen);
  });
})();
